import { ReactFragment, ReactNode } from "react";

export enum IResponseState {
  PENDING = "PENDING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING", // when some operation is completed but with some warning
}

export interface IResponseModalProps {
  show: boolean;
  state: IResponseState;
  showSuccessForwardMessage?: boolean;
  onClose:
    | (() => {})
    | (() => void)
    | React.MouseEventHandler<HTMLButtonElement>
    | undefined;
  failureMessage?: ReactFragment | string;
  infoMessage?: ReactFragment | string;
  customMessage?: ReactFragment | string;
  successExtraContent?: string;
  hideDefaultErrorMessage?: boolean;
}
